import {COLORS, Typography} from '@fupa/fupa-uikit';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {selectWebsocketData} from 'app/hooks/reduxCreateSelectorHooks';

const DOT_COLOR = COLORS.darkGrey;
const DOT_SIZE = 3;
const DOT_OFFSET_DEFAULT = 9999;
const DOT_OFFSET_LEFT = DOT_OFFSET_DEFAULT - DOT_SIZE * 1.5;
const DOT_OFFSET_RIGHT = DOT_OFFSET_DEFAULT + DOT_SIZE * 1.5;
const DOT_TYPING_DEFAULT = `${DOT_OFFSET_LEFT}px 0 0 0  ${DOT_COLOR},  ${DOT_OFFSET_DEFAULT}px 0 0 0  ${DOT_COLOR}, ${DOT_OFFSET_RIGHT}px 0 0 0  ${DOT_COLOR};`;

const DotTyping = styled.div`
  margin-left: 4px;
  margin-bottom: -4px;
  position: relative;
  left: -${DOT_OFFSET_DEFAULT}px;
  width: ${DOT_SIZE}px;
  height: ${DOT_SIZE}px;
  border-radius: 50%;
  background-color: ${DOT_COLOR};
  color:  ${DOT_COLOR};
  box-shadow: ${DOT_TYPING_DEFAULT}
  animation: dot-typing 1.5s infinite linear;

  @keyframes dot-typing {
    0% {
      box-shadow: ${DOT_TYPING_DEFAULT}
    }
    16.667% {
      box-shadow: ${DOT_OFFSET_LEFT}px -${DOT_SIZE}px 0 0  ${DOT_COLOR}, ${DOT_OFFSET_DEFAULT}px 0 0 0  ${DOT_COLOR}, ${DOT_OFFSET_RIGHT}px 0 0 0  ${DOT_COLOR};
    }
    33.333% {
      box-shadow: ${DOT_TYPING_DEFAULT}
    }
    50% {
      box-shadow: ${DOT_OFFSET_LEFT}px 0 0 0  ${DOT_COLOR}, ${DOT_OFFSET_DEFAULT}px -${DOT_SIZE}px 0 0  ${DOT_COLOR}, ${DOT_OFFSET_RIGHT}px 0 0 0  ${DOT_COLOR};
    }
    66.667% {
      box-shadow: ${DOT_TYPING_DEFAULT}
    }
    83.333% {
      box-shadow: ${DOT_OFFSET_LEFT}px 0 0 0  ${DOT_COLOR}, ${DOT_OFFSET_DEFAULT}px 0 0 0  ${DOT_COLOR}, ${DOT_OFFSET_RIGHT}px -${DOT_SIZE}px 0 0  ${DOT_COLOR};
    }
    100% {
      box-shadow: ${DOT_TYPING_DEFAULT}
    }
  }
`;

const CreatesEventRealtime = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RealtimeTypography = styled(Typography)`
  &&& {
    font-weight: bold;
  }
`;

const eventLabel = {
  goal: 'Tor',
  chance: 'Großchance',
  penalty_miss: 'verschossener Elfmeter',
  text: '',
  time_penalty: 'Zeitsperre',
  substitute: 'Wechsel',
  card_yellow: 'gelbe Karte',
  card_yellow_red: 'gelb-rote Karte',
  card_red: 'rote Karte',
};

const useIsTyping = () => {
  const [category, setCategory] = useState(null);
  const websocketData = useSelector(selectWebsocketData);

  useEffect(() => {
    if (websocketData?.event === 'state' && websocketData?.data?.liveticker?.typing) {
      // use state event of echo service to show "tippt..." even if event has occured before user has opened the connection to the websocket
      const text = eventLabel[websocketData.data.liveticker.type];
      setCategory(text);
    } else if (websocketData?.event === 'liveticker.start_typing') {
      const text = eventLabel[websocketData.data.type];
      setCategory(text);
    } else if (websocketData?.event === 'liveticker.stopped_typing') {
      setCategory(null);
    } else {
      setCategory(null);
    }
  }, [websocketData]);

  return category;
};

const MatchEventTyping = ({category}) => {
  if (category === null) {
    return null;
  }

  const categoryText = <RealtimeTypography variant='caption2'>{category}</RealtimeTypography>;
  const realtimeContent = (
    <>
      <Typography variant='caption2'>tippt</Typography>
      {categoryText}
      <DotTyping />
    </>
  );

  return <CreatesEventRealtime>{realtimeContent}</CreatesEventRealtime>;
};

export {useIsTyping, MatchEventTyping};
